import React from 'react'
import BaseImgBtn from './BaseImgBtn'

import img from 'assets/img/ic-undo.png'

const UndoBtn = (props: any) => {
  return <BaseImgBtn img={img} onClick={props.onClick} />
}

export default UndoBtn
